    import { Typography, Card } from '@mui/material';
    import { styled } from '@mui/material/styles';

    export const StyledCard = styled(Card)({
        borderRadius: '5px',
        marginTop: '0px',
        marginRight: '3px',
        marginLeft: '3px',
        height: '100px',
        width: '150px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    });
    
    export const StyledTypographyH5 = styled(Typography)({
        marginBottom: '0px',
        marginTop: '0px',
        textAlign: 'center',
    });

    export const StyledTypographyBody2 = styled(Typography)({
        marginBottom: '0px',
        marginTop: '0px',
        textAlign: 'center',
    });

    export const StyledTypographyLevel = styled(Typography)({
        color: '#737373',
        marginBottom: '0px',
        marginTop: '0px',
        textAlign: 'center',
        fontStyle: 'italic',
    });